<mat-form-field>
    <mat-label>Files uploaded by:</mat-label>
    <mat-select [formControl]="uploadedByType">
        <mat-option>--</mat-option>
        @for (uploaded_by_type of uploadedByTypes; track uploaded_by_type.code) {
        <mat-option [value]="uploaded_by_type.type">{{uploaded_by_type.description}}</mat-option>
        }
    </mat-select>
</mat-form-field>
